const EXCELHIRE_LOGIN_HOSTS = ["product.excelhire.com"];

const HAS_PROTOCOL_REGEX = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//;

const toNormalizedUrl = (rawUrl) => {
    const value = String(rawUrl || "").trim();
    if (!value) {
        return null;
    }

    return HAS_PROTOCOL_REGEX.test(value) ? value : `https://${value}`;
};

export const isExcelhireUrl = (rawUrl) => {
    const normalizedUrl = toNormalizedUrl(rawUrl);
    if (!normalizedUrl) {
        return false;
    }

    try {
        const hostname = new URL(normalizedUrl).hostname.toLowerCase();
        return EXCELHIRE_LOGIN_HOSTS.some((host) => host === hostname);
    } catch (_) {
        return false;
    }
};

